<template>
  <div>
    <el-dialog
      title="Cortando Cliente"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="25%"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="Motivos de Corte" prop="reason">
          <el-select v-model="form.reason" placeholder="Please select a zone">
            <el-option
              v-for="option in options"
              :key="option.value"
              :label="option.name"
              :value="option.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancel</el-button>
        <el-button type="primary" @click="OnSubmit" :loading="Loading"
          >Confirm</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "CuttingUserModal",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    Loading: {
      type: Boolean,
      default: false,
      required: false
    },
    formLabelWidth: {
      type: String,
      required: false
    },
    clientName: {
      type: String,
      default: "",
      required: true
    }
  },
  data() {
    return {
      form: {
        reason: ""
      },
      rules: {
        reason: [
          {
            required: true,
            message: "Por favor seleccione un motivo de corte",
            trigger: "change"
          }
        ]
      },
      options: [
        // { name: "Abierto", value: 0 },
        { name: "Cerrado", value: 1 },
        { name: "Suspendido por Pago", value: 2 },
        { name: "Cerrado por Legal", value: 3 },
        { name: "Cerrado por Clientes", value: 4 }
      ]
    };
  },
  computed: {
    DialogTitle() {
      return `Cortando Cliente ${this.clientName}`;
    }
  },
  methods: {
    handleClose() {
      this.$refs["form"].resetFields();
      this.$emit("ClosingDialog", false);
    },
    OnSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$emit("CuttingUser", this.form.reason);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
